import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { Button, Typography } from 'procyon-ui'

export const ConfirmationModal = ({
  title,
  message,
  onConfirm,
  onCancel,
  width = '600px',
  height = 'auto'
}) => {
  return (
    <div
      style={{
        width,
        height,
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0px 2px 4px rgba(34, 41, 69, 0.2)'
      }}
    >
      {/* TITLE ROW */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          color={'#d8a032'}
          style={{
            backgroundColor: 'rgba(216, 160, 50, 0.1)',
            borderRadius: '50%',
            padding: '8px'
          }}
        />
        <Typography
          variant='h4-medium'
          style={{
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {title}
        </Typography>
      </div>

      {/* MESSAGE */}
      {message && (
        <Typography variant='body-regular' style={{ marginLeft: '42px' }}>
          {message}
        </Typography>
      )}

      {/* BUTTONS ROW */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          marginTop: '24px'
        }}
      >
        <Button size='sm' variant='gray' onClick={onCancel} style={{ padding: '8px 16px' }}>
          Cancel
        </Button>

        <Button size='sm' variant='primary' onClick={onConfirm} style={{ padding: '8px 16px' }}>
          Confirm
        </Button>
      </div>
    </div>
  )
}
